export const VisitOrderConstants = {
  visitTypes: [
    { type: 'all', description: 'All Visit Types' },
    { type: 'true', description: 'SLV' },
    { type: 'false', description: 'Async' },
  ],

  VisitStatuses: {
    Open: 0,
    PendingReview: 1,
    UserCancelled: 2,
    Approved: 3,
    Closed: 4,
    Rejected: 5,
  },

  VisitTasks: {
    Questionnaire: 1,
    ExamVideo: 2,
    MultiPhoto: 3,
    SmartLiveVideo: 4,
    Payment: 5,
    Delivery: 6,
    AssignAffiliate: 7,
    AssignEMR: 8,
    DispatchTestKit: 9,
    TestResults: 10,
    PrescribeMedication: 11,
    Finalise: 12,
    Callback: 13,
    Account: 14,
    OrderLabs: 15,
    ReviewLabResults: 16,
  },

  VisitAdminStatuses: {
    All: { NumericValue: 'all', StringValue: 'All' },
    PaymentReceived: { NumericValue: 0.1, StringValue: 'Payment Received' },
    Complete: { NumericValue: 10, StringValue: 'Complete' },
    AdminCancelled: { NumericValue: 9.2, StringValue: 'Admin Cancelled' },
    LabOrderSent: { NumericValue: 7.0, StringValue: 'Lab Order Sent' },
    LabResultsReceived: { NumericValue: 7.7, StringValue: 'Lab Results Received' },
    New: { NumericValue: 0, StringValue: 'New' },
    QuestionnaireSubmitted: { NumericValue: 4.1, StringValue: 'Questionnaire Submitted' },
    DeliveryAddressSubmitted: { NumericValue: 4.2, StringValue: 'Delivery Address Submitted' },
    MultiPhotoUploaded: { NumericValue: 4.4, StringValue: 'Multi Photo Uploaded' },
    MultiPhotoReUploaded: { NumericValue: 4.5, StringValue: 'Multi Photo Re-uploaded' },
    IdPhotoUploaded: { NumericValue: 4.6, StringValue: 'Id Photo Uploaded' },
    IdPhotoReUploaded: { NumericValue: 4.7, StringValue: 'Id Photo Re-uploaded' },
    ExamPhotoUploaded: { NumericValue: 4.8, StringValue: 'Exam Photo Uploaded' },
    ExamPhotoReUploaded: { NumericValue: 4.9, StringValue: 'Exam Photo Re-uploaded' },
    MedicinePrescribed: { NumericValue: 5.1, StringValue: 'Medicine Prescribed' },
    MultiPhotoApproved: { NumericValue: 5.4, StringValue: 'Exam Photo Approved' },
    MultiPhotoRejected: { NumericValue: 5.5, StringValue: 'Exam Photo Rejected' },
    IdPhotoApproved: { NumericValue: 5.6, StringValue: 'Id Photo Approved' },
    IdPhotoRejected: { NumericValue: 5.7, StringValue: 'Id Photo Rejected' },
    ExamPhotoApproved: { NumericValue: 5.8, StringValue: 'Exam Photo Approved' },
    ExamPhotoRejected: { NumericValue: 5.9, StringValue: 'Exam Photo Rejected' },
    RemoteRxCreated: { NumericValue: 7.1, StringValue: 'Remote Rx Created' },
    RemoteRxSent: { NumericValue: 7.2, StringValue: 'Remote Rx Sent' },
    AssessmentOpen: { NumericValue: 8.1, StringValue: 'Assessment Open' },
    AssessmentComplete: { NumericValue: 8.2, StringValue: 'Assessment Complete' },
    Abandoned: { NumericValue: 9.8, StringValue: 'Expired' },
    UserCancelled: { NumericValue: 9.9, StringValue: 'User Cancelled' },
    PatientHistoryCheck: { NumericValue: 2.1, StringValue: 'Running patient history check' },
    AwaitingIdApproval: { NumericValue: 2.5, StringValue: 'Awaiting ID approval' },
    AwaitingIdUpload: { NumericValue: 2.4, StringValue: 'Additional ID Photos Requested' },
    AdditionalIdPhotosUploaded: { NumericValue: 4.61, StringValue: 'Additional ID Photos Uploaded' },
    AdditionalIdPhotosReUploaded: { NumericValue: 4.71, StringValue: 'Additional ID Photos Re-uploaded' },
    AdditionalPhotosApproved: { NumericValue: 5.61, StringValue: 'Additional ID Photos Approved' },
    AdditionalIdRejected: { NumericValue: 5.71, StringValue: 'Additional ID Photo Rejected' },
  },
};
